import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService } from 'src/app/shared/services/user-login.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import LoginRoutingPath from 'src/app/login/login-routing-path';

@Component({
  selector: 'app-delete-account-success',
  templateUrl: './delete-account-success.component.html',
  styleUrls: ['./delete-account-success.component.scss'],
})
export class DeleteAccountSuccessComponent {
  @Input() dialogRef?: any;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  constructor(
    private userService: UserLoginService,
    private router: Router,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService
  ) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.dialogRef?.close();
    this.userService.logout().subscribe({
      next: () => {
        this.stateManagementService.updateLoggedIn(false);
        this.dialogRef?.close(false);
        this.router.navigate([LoginRoutingPath.loginForm]);
      },
      error: () => {},
    });
  }
}
